export const impacts = {
    workingDays: "working_days",
    co2: "co2",
    areaPlanted: "area_planted",
    yield: "yield",
    oceanAreaPlanted: "ocean_area_planted",
};
